export default "__VITE_ASSET__BvyLNmpe__"